<template>
	<Layout>
		<div class="l-container">
			<EventCenter
				:context-id="contextId"
				:context-type="contextType"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import EventCenter from '@js/components/EventCenter/EventCenter';

export default {
	name:       'ViewEventCenter',
	components: {
		EventCenter,
		Layout,
	},
	props: {
		contextId: {
			type:     Number,
			required: true,
		},
		contextType: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style>

</style>
